import { render, staticRenderFns } from "./401.vue?vue&type=template&id=260820a8&scoped=true&"
import script from "./401.vue?vue&type=script&lang=js&"
export * from "./401.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260820a8",
  null
  
)

export default component.exports